import styled from 'styled-components';

// A pagina nao carrega mais o Materialize, entao `.btn`/`.btn-primary` nao tem
// estilo nenhum vindo de fora — o botao e estilizado aqui. Pelo mesmo motivo
// sairam os hacks que existiam para desfazer o CSS global nos labels.
export const FormWrapper = styled.form`
  display: flex;
  gap: 2em;
  width: 100%;

  .form-inputs {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .btn {
    align-items: center;
    background: #006bf3;
    border: 0;
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    display: inline-flex;
    font-size: 15px;
    font-weight: 600;
    justify-content: center;
    margin-top: 20px;
    padding: 14px 28px;
    transition: background 0.2s ease;
    width: 100%;
  }

  .btn:hover:not(:disabled) {
    background: #0056c6;
  }

  .btn:disabled {
    background: #9db9dd;
    cursor: not-allowed;
  }

  .margin-bottom-clear {
    margin-bottom: 0 !important;
  }

  @media screen and (max-width: 900px) {
    flex-direction: column;
    gap: 1em;
  }
`;

export const View = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  h1 {
    font-size: 26px;
    line-height: 1.2;
    margin: 0 0 24px;
    font-weight: 700;
  }

  a {
    color: #006bf3;
  }
`;

export const AvatarWrapper = styled.div`
  align-items: center;
  border: 2px dashed #dddddd;
  border-radius: 1.5em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 1.5em;
  max-width: 260px;
  padding: 1.2em;
  text-align: center;

  span {
    color: #5b6b7c;
    font-size: 12px;
    line-height: 1.4;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
`;
